import React from "react";
import "../../styles/About.css";

const FEATURES = [
  {
    title: "Manufaktur Fashion Berpengalaman Sejak 2016",
    desc: "Berdiri di Pati, Jawa Tengah, kami telah bertransformasi dari fase UMKM menjadi industri kreatif skala nasional dan internasional yang berfokus pada garment dan screen printing.",
  },
  {
    title: "Kapasitas Produksi Skala Besar",
    desc: "Kami sanggup memproduksi hingga 50.000 pcs per bulan untuk memastikan kebutuhan slot produksi pesanan Anda selalu tersedia, berapapun kuantitasnya.",
  },
  {
    title: "Standar Kualitas Terjamin & Bergaransi",
    desc: "Setiap produk melewati pengecekan ketat (Quality Control) mulai dari pemilihan bahan hingga finishing, serta dilengkapi dengan garansi demi menjamin kepuasan pelanggan.",
  },
  {
    title: "Layanan Profesional & Terpadu",
    desc: "Didukung oleh SDM ahli, kami menawarkan fasilitas konsultasi desain gratis dan penjadwalan produksi yang tersistem untuk memastikan pengiriman tepat waktu.",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="about section">
      <div className="container section-title" data-aos="fade-up">
        <h2>About Us</h2>
        <p>
          <span>Learn More</span>
          <span className="description-title">About Us</span>
        </p>
      </div>

      <div className="container">
        <div className="row gy-4">
          <div className="col-lg-7" data-aos="fade-up" data-aos-delay="100">
            <img
              src="assets/img/about.jpg"
              className="img-fluid mb-4"
              alt="About Us"
            />
            <div className="book-a-table">
              <h3>Contact Us</h3>
              <p>081 272 800 800</p>
            </div>
          </div>
          <div className="col-lg-5" data-aos="fade-up" data-aos-delay="250">
            <div className="content ps-0 ps-lg-5">
              <ul>
                {FEATURES.map((feature, idx) => (
                  <li key={idx}>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>
                      <strong>{feature.title}:</strong> {feature.desc}
                    </span>
                  </li>
                ))}
              </ul>
              <p className="para1">
                Kami adalah perusahaan fashion manufaktur yang berfokus pada
                screen printing dan garment. Dari fase UMKM, kini kami telah
                berkembang menjadi salah satu industri kreatif unggulan yang
                siap bersaing di kancah global.
              </p>

              <div className="position-relative mt-4">
                <img
                  src="assets/img/about-3.jpg"
                  className="img-fluid"
                  alt="Video"
                />
                <a
                  href="https://www.youtube.com/watch?v=QkCmjlbhXLg"
                  className="glightbox pulsating-play-btn"
                  data-type="video"
                  data-source="youtube"
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
